import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
import { Home } from './pages/Home';
import { Dining } from './pages/Dining';
import { DiningDetail } from './pages/DiningDetail';
import { Login } from './pages/Login';
import { Facilities } from './pages/Facilities';
import { FacilityDetail } from './pages/FacilityDetail';
import { Accommodation } from './pages/Accommodation';
import { Contact } from './pages/Contact';
import { About } from './pages/About';
import { Sports } from './pages/Sports';
import { SportsDetail } from './pages/SportsDetail';
import { Banquets } from './pages/Banquets';
import { BanquetDetail } from './pages/BanquetDetail';
import { Events } from './pages/Events';
import { EventDetail } from './pages/EventDetail';
import { Gallery } from './pages/Gallery';
import { AlbumDetail } from './pages/AlbumDetail';
import { Members } from './pages/Members';
import { MembersInformation } from './pages/MembersInformation';
import { MemberDashboard } from './pages/MemberDashboard';
import { MemberCard } from './pages/MemberCard';
import { AffiliatedClubs } from './pages/AffiliatedClubs';
import { AffiliatedClubDetail } from './pages/AffiliatedClubDetail';
import { Committee } from './pages/Committee';
import { Policies } from './pages/Policies';
import { AdminLayout } from './components/AdminLayout';
import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminMembers } from './pages/admin/AdminMembers';
import { AdminMemberDetail } from './pages/admin/AdminMemberDetail';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<SiteLayout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="about" element={<About data-id="element-7" />} data-id="element-6" />

          <Route path="facilities" element={<Facilities data-id="element-9" />} data-id="element-8" />
          <Route path="facilities/:slug" element={<FacilityDetail data-id="element-11" />} data-id="element-10" />

          <Route path="dining" element={<Dining data-id="element-13" />} data-id="element-12" />
          <Route path="dining/:slug" element={<DiningDetail data-id="element-15" />} data-id="element-14" />

          <Route path="sports" element={<Sports data-id="element-17" />} data-id="element-16" />
          <Route path="sports/:slug" element={<SportsDetail data-id="element-19" />} data-id="element-18" />

          <Route path="banquets" element={<Banquets data-id="element-21" />} data-id="element-20" />
          <Route path="banquets/:slug" element={<BanquetDetail data-id="element-23" />} data-id="element-22" />

          <Route path="accommodation" element={<Accommodation data-id="element-25" />} data-id="element-24" />

          <Route path="events" element={<Events data-id="element-27" />} data-id="element-26" />
          <Route path="events/:slug" element={<EventDetail data-id="element-29" />} data-id="element-28" />

          <Route path="gallery" element={<Gallery data-id="element-31" />} data-id="element-30" />
          <Route path="gallery/:slug" element={<AlbumDetail data-id="element-33" />} data-id="element-32" />

          <Route path="affiliated-clubs" element={<AffiliatedClubs data-id="element-35" />} data-id="element-34" />
          <Route path="affiliated-clubs/:slug" element={<AffiliatedClubDetail data-id="element-37" />} data-id="element-36" />

          <Route path="committee" element={<Committee data-id="element-39" />} data-id="element-38" />

          <Route path="members" element={<Members data-id="element-41" />} data-id="element-40" />
          <Route path="members/information" element={<MembersInformation data-id="element-43" />} data-id="element-42" />
          <Route path="members/dashboard" element={<MemberDashboard data-id="element-45" />} data-id="element-44" />
          <Route path="members/card" element={<MemberCard data-id="element-47" />} data-id="element-46" />
          <Route path="members/login" element={<Login data-id="element-49" />} data-id="element-48" />
          <Route path="login" element={<Login data-id="element-51" />} data-id="element-50" />

          <Route path="contact" element={<Contact data-id="element-53" />} data-id="element-52" />

          <Route path="privacy" element={<Policies data-id="element-55" />} data-id="element-54" />
          <Route path="terms" element={<Policies data-id="element-57" />} data-id="element-56" />
          <Route path="policies" element={<Policies data-id="element-59" />} data-id="element-58" />
        </Route>

        {/* Admin console (separate layout, no public header/footer) */}
        <Route path="/admin/login" element={<AdminLogin data-id="element-61" />} data-id="element-60" />
        <Route path="/admin" element={<AdminLayout data-id="element-63" />} data-id="element-62">
          <Route index element={<AdminDashboard data-id="element-65" />} data-id="element-64" />
          <Route path="members" element={<AdminMembers data-id="element-67" />} data-id="element-66" />
          <Route path="members/:id" element={<AdminMemberDetail data-id="element-69" />} data-id="element-68" />
        </Route>
      </Routes>
    </BrowserRouter>;
}